<template lang="pug">
  v-content
    Cuenta
    Lista
</template>

<script>
import Cuenta from '../../components/web/PedidoCuenta'
import Lista from '../../components/web/PedidoLista'
export default {
  components: {
    Cuenta,
    Lista
  },
  mounted () {
    this.$store.commit('cot/loadLocal')
  }
}
</script>
